import dateSiteOptions, {
  type DateSiteOptions,
} from '@/shared/lib/constants/dateSite';
import FilterTab, { type FilterTabProps } from '@/shared/ui/filter-tab';

interface SiteDateSwitchProps extends Pick<FilterTabProps, 'disabled'> {
  value: DateSiteOptions;
  onChange: (value: DateSiteOptions) => void;
}

export default function SiteDateSwitch({
  disabled,
  value = 'sites',
  onChange,
}: SiteDateSwitchProps) {
  return (
    <FilterTab
      items={dateSiteOptions}
      active={dateSiteOptions.find(({ id }) => value === id)}
      onChange={(id: DateSiteOptions) => {
        onChange(id);
      }}
      disabled={disabled}
    />
  );
}
